export default __webpack_public_path__ + "static/intro-tile-6-partnerships-abd773e21cda9169909e119691fd404e.jpg";